"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var keys_1 = require("./keys");
var utils_1 = require("../utils");
var constants_1 = require("../constants");
var types_1 = require("../types");
function encryptBytes(msg, key, opts) {
    return __awaiter(this, void 0, void 0, function () {
        var data, importedKey, _a, alg, iv, cipherBuf;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    data = utils_1.default.normalizeUtf16ToBuf(msg);
                    if (!(typeof key === 'string')) return [3 /*break*/, 2];
                    return [4 /*yield*/, keys_1.default.importKey(key, opts)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = key;
                    _b.label = 3;
                case 3:
                    importedKey = _a;
                    alg = (opts === null || opts === void 0 ? void 0 : opts.alg) || constants_1.DEFAULT_SYMM_ALG;
                    iv = (opts === null || opts === void 0 ? void 0 : opts.iv) || utils_1.default.randomBuf(16);
                    return [4 /*yield*/, globalThis.crypto.subtle.encrypt({
                            name: alg,
                            // AES-CTR uses a counter, AES-GCM/AES-CBC use an initialization vector
                            iv: alg === types_1.SymmAlg.AES_CTR ? undefined : iv,
                            counter: alg === types_1.SymmAlg.AES_CTR ? new Uint8Array(iv) : undefined,
                            length: alg === types_1.SymmAlg.AES_CTR ? constants_1.DEFAULT_CTR_LEN : undefined,
                        }, importedKey, data)];
                case 4:
                    cipherBuf = _b.sent();
                    return [2 /*return*/, utils_1.default.joinBufs(iv, cipherBuf)];
            }
        });
    });
}
exports.encryptBytes = encryptBytes;
function decryptBytes(msg, key, opts) {
    return __awaiter(this, void 0, void 0, function () {
        var cipherText, importedKey, _a, alg, iv, cipherBytes, msgBuff;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    cipherText = utils_1.default.normalizeBase64ToBuf(msg);
                    if (!(typeof key === 'string')) return [3 /*break*/, 2];
                    return [4 /*yield*/, keys_1.default.importKey(key, opts)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = key;
                    _b.label = 3;
                case 3:
                    importedKey = _a;
                    alg = (opts === null || opts === void 0 ? void 0 : opts.alg) || constants_1.DEFAULT_SYMM_ALG;
                    iv = cipherText.slice(0, 16);
                    cipherBytes = cipherText.slice(16);
                    return [4 /*yield*/, globalThis.crypto.subtle.decrypt({ name: alg,
                            // AES-CTR uses a counter, AES-GCM/AES-CBC use an initialization vector
                            iv: alg === types_1.SymmAlg.AES_CTR ? undefined : iv,
                            counter: alg === types_1.SymmAlg.AES_CTR ? new Uint8Array(iv) : undefined,
                            length: alg === types_1.SymmAlg.AES_CTR ? constants_1.DEFAULT_CTR_LEN : undefined,
                        }, importedKey, cipherBytes)];
                case 4:
                    msgBuff = _b.sent();
                    return [2 /*return*/, msgBuff];
            }
        });
    });
}
exports.decryptBytes = decryptBytes;
function encrypt(msg, key, opts) {
    return __awaiter(this, void 0, void 0, function () {
        var cipherText;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, encryptBytes(msg, key, opts)];
                case 1:
                    cipherText = _a.sent();
                    return [2 /*return*/, utils_1.default.arrBufToBase64(cipherText)];
            }
        });
    });
}
exports.encrypt = encrypt;
function decrypt(msg, key, opts) {
    return __awaiter(this, void 0, void 0, function () {
        var msgBytes;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, decryptBytes(msg, key, opts)];
                case 1:
                    msgBytes = _a.sent();
                    return [2 /*return*/, utils_1.default.arrBufToStr(msgBytes, 16)];
            }
        });
    });
}
exports.decrypt = decrypt;
function exportKey(key) {
    return __awaiter(this, void 0, void 0, function () {
        var raw;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, globalThis.crypto.subtle.exportKey('raw', key)];
                case 1:
                    raw = _a.sent();
                    return [2 /*return*/, utils_1.default.arrBufToBase64(raw)];
            }
        });
    });
}
exports.exportKey = exportKey;
exports.default = {
    encryptBytes: encryptBytes,
    decryptBytes: decryptBytes,
    encrypt: encrypt,
    decrypt: decrypt,
    exportKey: exportKey
};
//# sourceMappingURL=operations.js.map